import ExcelImportDialog from "./project/ExcelImportDialog";

const TYPES = ["Instagram Post", "Carousel", "Reel", "Story", "LinkedIn Post", "Facebook Post", "YouTube Video", "YouTube Short", "Blog", "Ad Creative", "Other"];
const PLATFORMS = ["Instagram", "Facebook", "LinkedIn", "YouTube", "Twitter/X", "TikTok", "Meta Ads", "Website"];
const STATUSES = ["Draft", "Pending Approval", "Approved", "Scheduled", "Published", "Changes Required"];

const nextMonthDay = (day) => {
  const d = new Date();
  const m = new Date(d.getFullYear(), d.getMonth() + 1, day);
  return `${m.getFullYear()}-${String(m.getMonth() + 1).padStart(2, "0")}-${String(m.getDate()).padStart(2, "0")}`;
};

const CONTENT_CONFIG = {
  title: "Import Content Plan from Excel", noun: "post", url: "/contents/import", sheet: "Content Plan", itemKey: "content",
  fileName: "AgencyOS-Content-Plan-Template.xlsx",
  requiredNote: "Client, Publishing Date and Topic are required.",
  columns: [
    ["Client", "client", "Required. Client or brand name exactly as in AgencyOS (Social Media clients you're assigned to)"],
    ["Publishing Date", "publishing_date", "Required. YYYY-MM-DD, e.g. 2026-11-05"],
    ["Publishing Time", "publishing_time", "Optional. 24h like 18:30 or 6:30 PM"],
    ["Topic", "content_topic", "Required. What the post is about"],
    ["Content Type", "content_type", `Optional. ${TYPES.join(" / ")} (default Instagram Post)`],
    ["Platform", "platform", `Optional. ${PLATFORMS.join(" / ")} (default Instagram)`],
    ["Content Pillar", "content_pillar", "Optional. e.g. Education, Product, Testimonial, Promo"],
    ["Caption", "caption", "Optional. Post caption"],
    ["Hashtags", "hashtags", "Optional. e.g. #brand #launch"],
    ["CTA", "cta", "Optional. Call to action, e.g. Shop now"],
    ["Status", "status", `Optional. ${STATUSES.join(" / ")} (default Draft)`],
  ],
  samples: [
    ["Your Brand", nextMonthDay(3), "10:30", "Product launch teaser", "Reel", "Instagram", "Product", "Something new is coming...", "#launch #comingsoon", "Follow for updates", "Draft"],
    ["Your Brand", nextMonthDay(7), "18:00", "Customer story", "Carousel", "Instagram", "Testimonial", "", "", "", "Draft"],
  ],
  previewCols: [["Client", "client"], ["Date", "publishing_date"], ["Time", "publishing_time"], ["Topic", "content_topic"], ["Type", "content_type"], ["Platform", "platform"], ["Status", "status"]],
};

export const ContentImportDialog = (props) => <ExcelImportDialog {...props} config={CONTENT_CONFIG} testid="content-import" />;
